<template>
  <div :class="{ 'form-group': label }">
    <label v-if="label" :class="`col-sm-${+labelCols} control-label`">{{ label }}</label>
    <div :class="label ? `col-sm-${12 - +labelCols}` : ''" class="selected-item-wrapper">
      <button
        v-if="buttonText && !disabled"
        class="btn btn-regular btn-small"
        type="button"
        @click="$emit('open')"
      >
        {{ buttonText }}
      </button>
      <div v-if="!multiple">
        {{ getItemText(value) }}
        <i v-if="clearable && !disabled" class="icon-close" @click="removeSelectedItem(value)"></i>
      </div>
      <div v-else>
        <div v-for="item in value" :key="getItemValue(item)">
          {{ getItemText(item) }}
          <i v-if="clearable && !disabled" class="icon-close" @click="removeSelectedItem(item)"></i>
        </div>
      </div>
      <div v-if="error" class="error-message">{{ error }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseListItemPicker',

  props: {
    value: {
      type: [String, Number, Array, Object],
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    labelCols: {
      type: [Number, String],
      default: 6,
    },
    multiple: {
      // value has to be an array if true
      type: Boolean,
      default: false,
    },
    textField: {
      type: [String, Array],
      default: 'name',
    },
    textPrefix: {
      type: String,
      default: '',
    },
    valueField: {
      type: String,
      default: 'code',
    },
    secondaryFieldsInParentheses: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getItemText(item) {
      if (!item) {
        return '';
      }

      let selectedItem;
      const valueType = typeof item;
      if (valueType === 'string' || valueType === 'number') {
        for (let i = 0; i < this.items.length; i += 1) {
          if (this.items[i][this.valueField] === item) {
            selectedItem = this.items[i];
            break;
          }
        }
      } else {
        selectedItem = item;
      }

      if (!selectedItem) {
        return this.value || '';
      }

      if (typeof this.textField === 'object') {
        // textField is array
        let text = '';
        this.textField.forEach((field, index) => {
          if (selectedItem[field]) {
            if (this.secondaryFieldsInParentheses && index > 0) {
              text += `(${selectedItem[field]}) `;
            } else {
              text += `${selectedItem[field]} `;
            }
          }
        });
        text = text.trim();
        return `${this.textPrefix}${text || ''}`;
      }

      return `${this.textPrefix}${selectedItem[this.textField] || ''}`;
    },

    getItemValue(item) {
      const valueType = typeof item;
      if (valueType === 'string' || valueType === 'number') {
        return item;
      }
      return item[this.valueField];
    },

    removeSelectedItem(item) {
      if (!this.multiple) {
        this.$emit('input', null);
      }
      const valueType = typeof item;
      const newValue = this.value.filter((i) => {
        if (valueType === 'string' || valueType === 'number') {
          return i !== item;
        }
        return i[this.valueField] !== item[this.valueField];
      });
      this.$emit('input', newValue);
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 30px;
}

.control-label {
  padding-top: 0 !important;
}

.icon-close {
  cursor: pointer;
  margin-left: 4px;
}
</style>
